module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note10 Aura Pink.108ee7ee.png";